import React from 'react'
import { Card, Container } from 'react-bootstrap'
import '../../features/products/MightyBucksGiftCardPage.scss';
import { useSelector } from 'react-redux';
import { selectToken } from '../../features/user/userSlice';
import { selectCartCoupon } from '../../features/cart/cartSlice';
import YourDiscounts from './components/YourDiscounts';
import { YourBenefits } from './components/YourBenefits';
import { WaysToSave } from './components/WaysToSave';
import { OnSaleProducts } from './components/OnSaleProducts';
import './core/mightyDealpage.scss';

const MightyDealsWrapper = () => {
    const token = useSelector(selectToken);
    const cartCoupon = useSelector(selectCartCoupon);

    return (
        <Container className="mightyBucks-page">
            <Card body className='border-0'>
                <div className='introducing-container'>
                    <div className='introducing'>
                        <h1>Mighty<span>Deals</span></h1>
                        <h2>Lots of Ways to Save BIG!</h2>
                        <p>Discover all your current promotions and rewards at a glance!</p>
                    </div>
                </div>
                {token && !cartCoupon && <YourDiscounts />}
                {token && <YourBenefits />}
                <WaysToSave />
                <OnSaleProducts />
            </Card>
        </Container>
    )
}

export default MightyDealsWrapper